import React from "react";
import {
  BLADE_COMPONENTS,
  type BladeRenderErrorContext,
} from "@riot-private/blades-ui";
import styles from "./ErrorBlade.module.css";

/** Safe presentation only: never receive or render the original exception or blade data. */
export const ErrorBlade: React.FC<BladeRenderErrorContext> = ({
  phase,
  index,
  bladeType,
}) => {
  const position =
    Number.isSafeInteger(index) && index >= 0 && index < Number.MAX_SAFE_INTEGER
      ? `Blade ${index + 1}`
      : undefined;
  const knownType =
    typeof bladeType === "string" &&
    bladeType.length > 0 &&
    bladeType.length <= 128 &&
    Object.prototype.hasOwnProperty.call(BLADE_COMPONENTS, bladeType)
      ? bladeType
      : undefined;

  return (
    <div data-testid="error-blade" className={styles.wrapper} role="alert">
      <h2 className={styles.heading}>This blade could not render</h2>
      <p className={styles.errorMessage}>
        {phase === "validation" ? "Validation failure" : "Render failure"}
        {position ? ` · ${position}` : null}
        {knownType ? ` · ${knownType}` : null}
      </p>
    </div>
  );
};
